<template>
    <div>
        <swb-org-biz-param-list :channelCode="'bizParamComn'"></swb-org-biz-param-list>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbOrgBizParamList from './OrgBizParamList';
    Vue.regist(SwbOrgBizParamList);
    //
    export default{
        name: 'swb-biz-param-list-for-comn',
        path: '/biz/param/list/for/comn',
        avlScopes: 'retailer',
        desc: '综合管理-业务参数',
        helpArticleCode: 'servicer-biz-param-list-for-comn',
        data: function () {
            return {
                groupCodeList: []
            }
        },
        created: function () {
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/BizParamListForComn.vue